'use client';

import React, { Suspense, lazy } from 'react';

interface ConfettiAnimationProps {
  showFreeShippingConfetti: boolean;
  showDiscountConfetti: boolean;
}

/**
 * The confetti artwork is ~100KB of inline SVG paths. The banner that renders it sits inside the cart
 * drawer, which the Header mounts on every page, so the artwork used to ship in the root layout for
 * every visitor whether or not a milestone was ever reached. It is now fetched only when a milestone
 * is actually achieved (SSD-6268).
 */
const ConfettiAnimationSvg = lazy(() =>
  import('./ConfettiAnimationSvg').then((module) => ({ default: module.ConfettiAnimationSvg })),
);

export function ConfettiAnimation({ showFreeShippingConfetti, showDiscountConfetti }: ConfettiAnimationProps) {
  if (!showFreeShippingConfetti && !showDiscountConfetti) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ConfettiAnimationSvg
        showFreeShippingConfetti={showFreeShippingConfetti}
        showDiscountConfetti={showDiscountConfetti}
      />
    </Suspense>
  );
}
